import React, { useEffect, useState } from "react";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { useNavigate, useParams } from "react-router-dom";
import Apis from "../../Apis";
import Loading from "../../loading/Loading";
import { showAlert } from '../../ui/dialog';
import { FiUser, FiMail, FiHash, FiToggleRight } from 'react-icons/fi';
import FormWizard from '../../ui/FormWizard';
import { InputField, SelectField, FormRow } from '../../ui/InputField';

const AlterarRepresentante = () => {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [cnpjCpf, setCnpjCpf] = useState('');
    const [status, setStatus] = useState('');
    const [validCpfCnpj, setValidCpfCnpj] = useState();
    const [loading, setLoading] = useState(false);
    const [rotasServer, setRotasServer] = useState([]);
    const [rotas, setRotas] = useState([]);
    const navigate = useNavigate();
    const parametro = useParams();

    useEffect(() => {
        if (cnpjCpf.length >= 11 && cnpjCpf.length <= 18) {
            setValidCpfCnpj(cpf.isValid(cnpjCpf) || cnpj.isValid(cnpjCpf) ? true : false);
        }
    }, [cnpjCpf]);

    useEffect(() => {
        setLoading(true);
        fetch(Apis.urlListarOneRepresentantes, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({ "id": parametro.id })
        }).then(r => r.json()).then(result => {
            if (result.retorno.sucesso) {
                setRotas(result.registros[0]?.rotas);
                setNome(result.registros[0]?.nome);
                setEmail(result.registros[0]?.email);
                setCnpjCpf(result.registros[0]?.cnpj_cpf);
                setStatus(result.registros[0]?.status);
                setLoading(false);
            } else {
                navigate('/listar-representantes');
            }
        });
    }, []);

    useEffect(() => {
        fetch(Apis.urlListarRotas, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
            body: JSON.stringify({})
        }).then(r => r.json()).then(result => setRotasServer(result.registros));
    }, []);

    const alertaErro = (texto) => showAlert({ title: "Atenção", text: texto, icon: "error", dangerMode: true });

    const handleRotas = (rota) => {
        const existe = rotas.some(r => r.id === rota.id);
        if (!existe) setRotas([...rotas, { "id": rota.id, "nome": rota.nome }]);
        else setRotas(rotas.filter(r => r.id !== rota.id));
    };

    const handleSubmit = () => {
        if (validCpfCnpj === false || cnpjCpf.length < 11) { alertaErro("CPF/CNPJ inválido!"); return; }
        if (status !== '' && nome !== '' && email !== '' && cnpjCpf !== '' && parametro.id !== '') {
            setLoading(true);
            fetch(Apis.urlAlterarRepresentante, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `${localStorage.getItem('token')}` },
                body: JSON.stringify({ "status": status, "nome": nome, "email": email, "cnpj_cpf": cnpjCpf, "id": parametro.id, "rotas": rotas })
            }).then(r => r.json()).then(result => {
                if (result.retorno.sucesso) {
                    navigate(`/alerta-sucesso/${result.retorno.mensagem}&listar-representantes`);
                } else {
                    alertaErro(result.retorno.mensagem);
                }
                setLoading(false);
            });
        } else {
            alertaErro("Preencha todos os campos");
        }
    };

    if (loading) return <Loading />;

    return (
        <FormWizard
            title="Alteração de Representante"
            icon={<FiUser />}
            steps={['Dados Pessoais', 'Rotas']}
            onSubmit={handleSubmit}
            submitLabel="Salvar Alterações"
        >
            {/* Passo 1 — Dados Pessoais */}
            <>
                <InputField label="Nome" icon={<FiUser />} required
                    placeholder="Nome completo"
                    onChange={e => setNome(e.target.value)} value={nome} />
                <FormRow>
                    <InputField label="E-mail" icon={<FiMail />}
                        placeholder="E-mail"
                        onChange={e => setEmail(e.target.value)} value={email} />
                    <InputField label="CNPJ / CPF" icon={<FiHash />} required
                        placeholder="CNPJ ou CPF"
                        onChange={e => setCnpjCpf(e.target.value)} value={cnpjCpf} />
                </FormRow>
                <SelectField label="Status" icon={<FiToggleRight />}
                    onChange={e => setStatus(e.target.value)} value={status}>
                    <option value="0">Inativo</option>
                    <option value="1">Ativo</option>
                </SelectField>
            </>

            {/* Passo 2 — Rotas */}
            <>
                {rotas?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '10px 12px', background: '#f8fafc', borderRadius: 10 }}>
                        {rotas.map(rota => (
                            <span key={rota.id} style={{ padding: '3px 10px', borderRadius: 20, background: '#edf6fb', color: '#162e3c', fontSize: 12, fontWeight: 600, textTransform: 'uppercase' }}>
                                {rota.nome}
                            </span>
                        ))}
                    </div>
                )}
                <p style={{ fontSize: 12, color: '#64748b', margin: 0 }}>
                    {!rotas?.length ? 'Nenhuma rota selecionada. Clique para adicionar:' : 'Clique para adicionar ou remover:'}
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {rotasServer?.map(rotaServer => {
                        const selected = rotas?.some(r => r.id === rotaServer.id);
                        return (
                            <button key={rotaServer.id} type="button" onClick={() => handleRotas(rotaServer)}
                                style={{
                                    padding: '11px 16px', borderRadius: 4, textAlign: 'left',
                                    border: `1.5px solid ${selected ? '#1e3a4c' : '#e2e8f0'}`,
                                    background: selected ? '#edf6fb' : '#fff',
                                    color: selected ? '#162e3c' : '#374151',
                                    fontWeight: selected ? 600 : 400,
                                    fontSize: 13, textTransform: 'uppercase',
                                    cursor: 'pointer', transition: 'all 0.15s',
                                    display: 'flex', alignItems: 'center', gap: 10,
                                }}>
                                <div style={{ width: 18, height: 18, borderRadius: 5, flexShrink: 0, border: selected ? 'none' : '2px solid #cbd5e1', background: selected ? 'linear-gradient(135deg, #3d7a9c, #1e3a4c)' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {selected && <span style={{ color: '#fff', fontSize: 10, fontWeight: 700 }}>✓</span>}
                                </div>
                                {rotaServer.nome}
                            </button>
                        );
                    })}
                </div>
                {(!rotasServer || rotasServer.length === 0) && (
                    <p style={{ fontSize: 13, color: '#94a3b8', textAlign: 'center', padding: '16px 0' }}>
                        Nenhuma rota cadastrada.
                    </p>
                )}
            </>
        </FormWizard>
    );
};

export default AlterarRepresentante;
